import { BookingStateEnum } from '@xeetr/types/enums'
import { BaseBookingModel } from '@xeetr/types/models'
import { addMinutes, isAfter } from 'date-fns'
import { useCallback, useContext } from 'react'

import { ActiveTenantContext } from '../../context/common/Context'

interface ReturnType {
  handleRowStyle: (booking: BaseBookingModel) => Record<string, boolean>
}

export const useRowStyle = (): ReturnType => {
  const { tenant } = useContext(ActiveTenantContext)

  const handleRowStyle = useCallback(
    (booking: BaseBookingModel) => {
      const expirationTime = tenant?.thresholdOutdated ?? 0
      const isExpired = isAfter(new Date(), addMinutes(booking.from, expirationTime))
      const isCheckIn = booking.state?.status === BookingStateEnum.CHECKEDIN
      return {
        '!text-orange-400': !isCheckIn && isExpired && !!tenant?.highlightOutdated,
        '!text-primary': isCheckIn,
        'text-base': true,
      }
    },
    [tenant]
  )
  return { handleRowStyle }
}
